<template>
  <div>
    <select class="common_select" @change="onChange">
      <option v-for="(item, n) in items" :key="n" :value="item.value" :selected="item.selected">
        {{item.name}}
      </option>
    </select>
  </div>
</template>

<script>
import UT from '@/common/util';
import { SEMESTERS } from "@/common/define";

export default {
  name: "SelectYearSemester",
  props: {
    value: Array,
  },
  data: () => ({
    items: [],
  }),
  computed: {
  },
  methods: {
    onChange(evt) {
      this.items.forEach((item, i) => {
        item.selected = i === evt.srcElement.selectedIndex ? true : false;
      });
      this.changed();
    },
    changed() {
      let selected = this.items.filter((item) => {
        return item.selected;
      });
      this.$emit("input", selected[0].value);
    },
    requesItems() {
      let req = {
        url: '/api/user/ys',
        data: {
          user_id: this.$session.get("user_id")
        }
      };
      UT.api(req).then((res) => {
        this.items = [];
        if (res.data && res.data.result) {
          let data = res.data.result;
          let ys = [];
          Object.entries(data).forEach((item) => {
            item[1].forEach((row) => {
              ys.push({year: item[0], semester: row});
            });
          });
          ys = ys.sort(function(a, b) {
            let v1 = parseInt(`${a.year}${a.semester}`, 10);
            let v2 = parseInt(`${b.year}${b.semester}`, 10);
            return v2 - v1;
          });
          this.items = ys.map((item, i) => {
            return {
              name: this.$i18n.translate(`{0}년도{1}`, item.year, SEMESTERS[item.semester]),
              value: [item.year, item.semester],
              selected: i === 0
            };
          });
        }
        this.changed();
      });
    }
  },
  created() {
    this.requesItems();
  },
  beforeMount() {
    let me = this;
    this.items.forEach((item) => {
      item.selected = (item.value === me.value ? true : false);
    });
  },
  watch: {
  }
}
</script>
